import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AbilityService } from '../../../_shared/services/ability.service';
import { UtilService } from '../../../_shared/services/util.service';

import { LanguageService } from '../../../languages/shared/language.service';

import { Facility } from '../../shared/facility.model';
import { FacilityService } from '../../shared/facility.service';
import { FacilityListComponent } from '../../facility-list/facility-list.component';
import { FacilityDetailComponent } from '../../facility-detail/facility-detail.component';

@Component({
  selector: 'app-facilities-modal',
  templateUrl: './facilities-modal.component.html',
  standalone: true,
  imports: [SharedModule, FacilityListComponent, FacilityDetailComponent],
})
export class FacilitiesModalComponent {
  constructor(
    private facilityService: FacilityService,
    private languageService: LanguageService,
    private abilityService: AbilityService,
    private utilService: UtilService,
    private ref: MatDialogRef<FacilitiesModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getAdditionalLanguages();
  }

  // @Output() private dialogSaved = new EventEmitter<any>(); // avoid closing the dialog

  modalTitle = this.data.title;
  // lang = this.data.params.lang;

  facilities: Facility[];
  meta = [];
  facility: Facility;
  mode = '';
  loadingFacilities = false;

  listMode = true;
  detailMode = false;

  permissions = {
    canList: this.abilityService.can('index_facility_accountadmin'),
    canCreate: this.abilityService.can('create_facility_accountadmin'),
  };

  defaultLanguage: any;

  private filterCriteria = this.facilityService.getFilterCriteria();
  additionalLanguages = [];

  showFacilities() {
    this.modalTitle = this.data.title;

    this.listMode = true;
    this.detailMode = false;

    this.getFacilities();
  }

  addFacility() {
    this.modalTitle = 'ADD_FACILITY';
    this.listMode = false;
    this.detailMode = true;

    this.facility = {};
  }

  // Referenced from app-facility-detail
  onSavedFacility(facility) {
    this.facility = facility;

    this.listMode = true;
    this.detailMode = false;

    this.getFacilities(facility);
  }

  // Referenced from app-facility-detail
  onCanceledFacility() {
    this.showFacilities();
  }

  close() {
    this.ref.close(true);
  }

  // Referenced from app-facility-list
  onSelectedFacility({ facility, mode = '' }) {
    this.facility = facility;
    this.mode = mode;

    this.modalTitle = 'FACILITY_DETAILS';
    this.listMode = false;
    this.detailMode = true;
  }

  private getFacilities(selectedFacility = null) {
    this.filterCriteria.lang = this.defaultLanguage.lang;
    // this.filterCriteria['skip_check_role'] = true;

    this.loadingFacilities = true;
    this.facilityService.getFacilities(this.filterCriteria).subscribe((response) => {
      this.facilities = response.data;
      this.meta = response.meta;

      this.loadingFacilities = false;

      if (selectedFacility) {
        this.utilService.changeItemRowStyle(selectedFacility.id);
      }
    });
  }

  private getAdditionalLanguages() {
    this.languageService.getLanguages({ skip_check_role: true }).subscribe((response) => {
      this.defaultLanguage = response.data.find((language) => language.is_default);
      this.additionalLanguages = response.data.filter((language) => !language.is_default);

      this.getFacilities();
    });
  }
}
